import React, { useState, useEffect } from "react";
import { Row, Col, Spin, Form, Card, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const LOCALE = "en";
const DATE_FORMAT_LOCALE = "dd MMMM yyyy";

const STATIC_ALLOTMENT_OPTIONS = [
  { label: "Allotment ALT-2026-001", value: 1 },
  { label: "Allotment ALT-2026-002", value: 2 },
  { label: "Allotment ALT-2026-003", value: 3 },
];

const Tip = ({ text, tip }) => (
  <span>
    {text}
    <Tooltip title={tip}>
      <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
    </Tooltip>
  </span>
);

const ConvertAllotmentToTrade = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [allotmentOptions, setAllotmentOptions] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const auctionId = location.state;
  const { userData } = props;
  const { session } = userData || {};
  const [lineMap, setLineMap] = useState({});

  useEffect(() => {
    if (auctionId) fetchAllotments(auctionId);
  }, []);

  const fetchTemplate = (id) => {
    const body = { session };
    const url = `${apiConfig.GetAuctions}/auctions/${id}/bids/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to load template.",
        );
        return;
      }

      // Build auctionLineId -> tenorDays lookup
      const map = {};
      (res?.lines || []).forEach((l) => {
        map[l.auctionLineId] = l.tenorDays;
      });
      setLineMap(map);
    });
  };

  const fetchAllotments = (id) => {
    setIsLoading(true);
    const body = { session };
    const url = `${apiConfig.GetAuctions}/auctions/${id}/allotments`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.defaultUserMessage || "Failed to load allotments.",
        );
        setIsLoading(false);
        return;
      }

      if (Array.isArray(res)) {
        setAllotmentOptions(
          res.map((a) => {
            const tenorDays = lineMap[a.auctionLineId];
            const label = tenorDays
              ? `${tenorDays}-Day | ${a.allottedAmount} | ${a.allottedRate}% | ${a.status}`
              : `Allotment #${a.allotmentId} | ₦${a.allottedAmount} | ${a.allottedRate}% | ${a.status}`;
            return { label, value: a.allotmentId };
          }),
        );
      }

      setIsLoading(false);
    });
  };

  const onFinish = (values) => {
    if (!auctionId) {
      BOM.AlertMsg(
        cnt.DANGER,
        "Trade ID is missing. Please go back and try again.",
      );
      return;
    }

    const body = {
      session,
      method: "POST",
      locale: LOCALE,
      dateFormat: DATE_FORMAT_LOCALE,
      auctionId,
      allotmentId: values.allotmentId,
    };

    const url = `${apiConfig.GetTrades}/trades/convert-allotment`;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to convert allotment to trade.",
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Allotment converted to trade successfully.");
      setIsLoading(false);
      navigate(-1);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.viewAuction}>
      <TopContent pageTitle={labelConfig.convertTradeToAllotment} />
      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Convert Allotment to Trade
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <Tip
                        text="Allotment"
                        tip="Select the allotment to convert into this trade."
                      />
                    }
                    name="allotmentId"
                    rules={[
                      { required: true, message: "Allotment is required" },
                    ]}
                  >
                    <Select
                      style={{ height: 44 }}
                      suffixIcon={<ChevronDown color="#667085" />}
                      options={allotmentOptions}
                      placeholder="Select Allotment"
                      showSearch
                      optionFilterProp="label"
                      notFoundContent="No allotments available"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Convert
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(
  ConvertAllotmentToTrade,
);
